<template>
  <div
    class="w-full p-4 flex items-center text-start dark:bg-gray-900 dark:text-gray-300"
    :class="{ 'cursor-pointer': action == 'expand' }"
  >
    <Icon :name="icon" class="flex-shrink-0 w-7 h-7 me-3 text-gray-500" />
    <div
      class="flex-grow flex"
      :class="{ 'flex-col-reverse': reverse, 'flex-col': !reverse }"
    >
      <p class="text-xs text-gray-500 leading-tight">
        <slot>{{ desc }}</slot>
      </p>
      <p class="font-medium text-sm leading-tight break-word">{{ label }}</p>
    </div>
    <Icon
      v-if="!readonly"
      :name="$options.actionIcons[action]"
      class="flex-shrink-0 w-6 h-6 text-gray-400 hover:text-gray-700 ms-2"
      :class="{ 'cursor-pointer': action == 'remove' }"
      @click="$emit('action')"
    />
  </div>
</template>

<script>
export default {
  actionIcons: {
    expand: "MdiChevronRight",
    remove: "MdiCloseCircle",
  },
  props: {
    label: String,
    desc: String,
    icon: String,
    reverse: Boolean,
    readonly: Boolean,
    action: {
      type: String,
      default: "expand",
    },
  },
};
</script>
